import template from './employee_leave_entry.html';
import * as Utils from '../../lib/savanna_utils.js';
import * as Navbar from '../../lib/update_navbar_notifications.js';
import tr from '../../lib/default-translator.js';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';

class EmployeeLeaveEntryViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.leave_type_id = ko.observable();
		this.available_leave_types = ko.observableArray();
		this.date_start = ko.observable();
		this.date_end = ko.observable();
		this.amount = ko.observable(0);
		this.is_overlapping = ko.observable();
		this.is_amount_editable = ko.observable(false);
		this.amount_info = ko.observable('');
		this.reason = ko.observable();
		this.leave_taken_id = ko.observable();
		this.available_leave_types = ko.observableArray();
		this.leave_linked_id = ko.observable();
		this.leave_taken_and_requests = ko.observable();
		this.taken_rate = ko.observable();
		this.leave_summary = ko.observableArray();
		this.summary_filter_earned_end = ko.observable(Utils.toJSONDateString(new Date())); // today
		this.has_attachment = ko.observable(false);
		this.customization_front_end_fields = ko.observableArray();
		this.today = ko.observable(Utils.toJSONDateString(new Date()));
		this.batch_file = ko.observable();
		this.selected_leave_type = ko.observable();
		this.holidays = ko.observableArray([]);
		this.event_dates = ko.observableArray([]);
		this.start_date_picker = null;
		this.end_date_picker = null;
		this.today = new Date().toISOString().split('T')[0];

		$('input[id=batch_file]').change((event) => {
			let file = event.target.files[0]
			if (file) {
				$('#upload_input').val(file.name)
				this.has_attachment(true)
			} else {
				$('#upload_input').val('')
				this.has_attachment(false)
			}
		})

		this.leave_linked_id.subscribe((val) => {
			let leave_selected_id = val;
			this.dialog.calculate_data();
			this.dialog.load_custom_fields(leave_selected_id);
		});
		this.date_start.subscribe((val) => {
			if (val) {
				this.end_date_picker.set('minDate', val); // Ensure end date can't be before start date
				this.date_end(val); // Set the end date to the next work day
				this.end_date_picker.setDate(this.date_end()); // Set the date to the current end date
				this.start_date_picker.close(); // Close the start date picker
			}
			this.dialog.calculate_data(); 
		});
		
		this.date_end.subscribe((val) => {
			if (val) {
				this.end_date_picker.close();
				this.dialog.calculate_data(); 
			}
		});
		this.on_leave_type_change = () => {
			let selected_value = this.selected_leave_type();
			if (selected_value) {
				let parts = selected_value.split('|');
				this.leave_linked_id(parts[0]);
				this.leave_type_id(parts[1]);
			}
		};
	}

	async save_leave()
	{
		this.dialog.global_save_ok = true; // reset
		this.dialog.leave_restriction_queue = new Array(); // reset
		let URL;

		// convert ko object to normal object
		let data_fields = ko.toJS(this.customization_front_end_fields());

		let data = {
			employee_id: this.dialog.bindings.employee_id,
			leave_type_id: this.leave_type_id(),
			date_start: this.date_start(),
			leave_linked_id: this.leave_linked_id(),
			date_end: this.date_end(),
			is_amount_editable: this.is_amount_editable(),
			amount: this.amount(),
			reason: this.reason(),
			amount_info: this.amount_info(),
			taken_rate: this.taken_rate(),
			is_overlapping: this.is_overlapping(),
			force_request: true
		};

		// add custom frontend field
		for (let a = 0; a < data_fields.length; a++)
		{
			data[data_fields[a].vname] = data_fields[a].value;
		}

		if (data.leave_taken_id == null)
			data.leave_taken_id = -1;

		URL = '/leave/save';
		if (data.leave_taken_id != -1)
			URL = '/leave/edit';
		
		// validation
		let valid = true;
		let msg = '';
		if (data.date_start == '')
		{
			valid = false;
			msg = tr('Please make sure your start date is correct before saving');
		}
		else if (data.date_end == '')
		{
			valid = false;
			msg = tr('Please make sure your end date is correct before saving');
		}
		else if (isNaN(Number(data.amount)) || Number(data.amount) <= 0)
		{
			valid = false;
			msg = tr('Please make sure your amount of days is a positive number');
		}
		else if (data.date_end == data.date_start && Number(data.amount) > 1)
		{
			let response = await Grape.alerts.confirm({type: 'warning', title: tr('Notice'),
				message: tr('Please note that you are trying to save a value greater than 1 for a single day.This is not recommended.\nDo you wish to save anyway?'),
				accept_text: 'Proceed',
				cancel_text: 'Cancel'
			});
			if (response)
			{}
			else
			{
				valid = false;
				document.getElementById("save_button").disabled = false;
				msg = tr('Leave not saved - cancelled by user.');
			}
		}
		else if (data.is_overlapping == true)
		{
			let response = await Grape.alerts.confirm({type: 'warning', title: tr('Notice'),
				message: tr('Please note that you are trying to save leave that is overlapping current leave processed.\nDo you wish to save anyway?'),
				accept_text: 'Proceed',
				cancel_text: 'Cancel'
			});
			if (response)
			{}
			else
			{
				valid = false;
				document.getElementById("save_button").disabled = false;
				msg = tr('Leave not saved - cancelled by user.');
			}
		}

		if (valid == true)
		{
			let res = await Grape.fetches.postJSON('/leave/check_leave_restrictions', data);
			if (res.status == 'OK')
			{
				// check for restriction failures and apply logic based on bahaviours
				if (res.restriction_results != null)
				{
					// Add all failed restrictions to the queue for processing
					for (let a = 0; a < res.restriction_results.length; a++)
					{
						let restriction_result = res.restriction_results[a];
						if (restriction_result.result == 'FAILURE')
							this.dialog.leave_restriction_queue.push(restriction_result);
					}
					this.dialog.process_NEXT_leave_restriction_queue_item(data);
				}
				else
					this.dialog.process_NEXT_leave_restriction_queue_item(data);
			}
			else if (res.status == 'ERROR')
			{
				document.getElementById("save_button").disabled = false;
				Grape.alerts.apiError(res);
			}
			else
			{
				document.getElementById("save_button").disabled = false;
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
			}
		}
		else
		{
			document.getElementById("save_button").disabled = false;
			Grape.alerts.alert({ type: 'error', message: msg, title: tr('Error', 'Error') });
		}

		
	};

	initialize_datepickers(res_requests)
	{
		let calendar_config = {
			dateFormat: 'Y-m-d',
			allowInput: true,
			onDayCreate: (dObj, dStr, fp, dayElem) => {
				let date_string = new Date(dayElem.dateObj.getTime() - (dayElem.dateObj.getTimezoneOffset() * 60000))
				.toISOString()
				.split('T')[0];
			

				let event = this.event_dates().find(e => e.date === date_string);
				
				if (event)
				{
					dayElem.classList.add(event.css_class);
					dayElem.style.backgroundColor = event.hexcolor;
					dayElem.setAttribute('title', event.name);
				}

				if (date_string == this.today)
				{
					dayElem.classList.add('today');
				}
			},
			appendTo: document.body, // This ensures the calendar is appended to the body
			static: true, // This prevents the calendar from being constrained within its parent container
		};

		this.start_date_picker = flatpickr('#datepicker_start', {
			...calendar_config,
			defaultDate: this.date_start() || null
		});
		
		this.end_date_picker = flatpickr('#datepicker_end', {
			...calendar_config,
			defaultDate: this.date_end() || null
		});
	}

	async load_events()
	{
		try
		{
			let res_requests = await Grape.fetches.postJSON('/leave/get_leave_taken_and_requests', { employee_id: this.dialog.bindings.employee_id });
			if (res_requests.status !== 'ERROR')
			{
				this.parse_leave(res_requests);
				if (this.start_date_picker && this.end_date_picker)
				{
					this.start_date_picker.destroy(); // Destroy existing pickers
					this.end_date_picker.destroy(); // Destroy existing pickers
				}
				
				this.initialize_datepickers(res_requests);
			}
		} catch (error)
		{
			Grape.alerts.alert({ type: 'error', message: tr('Failed to load leave and holiday data'), title: tr('Error') });
		}
	}
	
	parse_leave(res)
	{
		let event_dates = [];

		// Parse finalized leave
		if (res.all_finalized_leave && res.all_finalized_leave.length > 0)
			event_dates = event_dates.concat(this.parse_final_leave(res.all_finalized_leave));

		// Parse leave to approve - BUT skip rejected leave requests
		if (res.all_leave_to_approve && res.all_leave_to_approve.length > 0)
		{
			// Filter out rejected leave requests before processing
			let approvedLeaveRequests = res.all_leave_to_approve.filter(leave => leave.approved !== 'rejected');
		
			if (approvedLeaveRequests.length > 0)
			{
				let requestedDates = this.parse_final_dates(approvedLeaveRequests.flatMap(leave => leave.dates_included));
				event_dates = event_dates.concat(requestedDates);
			}
		}

		// Parse holidays (assuming holidays are included in the response)
		if (this.holidays && this.holidays().length > 0) {
			let holiday_dates = this.parse_holidays(this.holidays());
			event_dates = event_dates.concat(holiday_dates);
		}

		this.event_dates(event_dates);
	}
	
	parse_final_leave(finalizedLeave)
	{
		return finalizedLeave.flatMap(leave =>
			leave.dates_included.map(date => ({
				date: date,
				css_class: leave.css_class_name,
				hexcolor: leave.hexcolor,
				name: `${leave.leave_type} (Finalised)`
			}))
		);
	}
	
	parse_final_dates(dateArray)
	{
		return dateArray.map(date => ({
			date: date,
			css_class: 'request_date',
			hexcolor: '#fff3cd',
			name: 'Requested Leave day'
		}));
	}
	
	parse_holidays(holidays)
	{
		return holidays.map(holiday => ({
			date: holiday.holiday_date,
			css_class: holiday.css_class_name,
			hexcolor: holiday.hexcolor,
			name: holiday.description
		}));
	}

	close()
	{
		this.dialog.close();
	}
};

class EmployeeLeaveEntryPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeLeaveEntryViewModel(this);
		this.bindings = bindings;
		this.global_save_ok = true;
		this.leave_restriction_queue = [];

		document.querySelector('.ps-dialog').classList.add('employee-leave-entry-dialog');

	};

	async init()
	{
		document.getElementById("save_button").disabled = false;
		let res_linked_leave = await Grape.fetches.postJSON('/leave/get_linked_leave', { employee_id: this.bindings.employee_id });
		if (res_linked_leave.status !== 'ERROR') {
			this.viewModel.available_leave_types(res_linked_leave);
		}
		let res_leave = await Grape.fetches.getJSON('/leave/' + this.bindings.employee_id + '/summary/2000-01-01/' + this.viewModel.summary_filter_earned_end(),{});
		if (res_leave.status != 'ERROR')
			this.viewModel.leave_summary(ko.mapping.fromJS(res_leave));

		await this.load_calendar_colors();
		await this.load_holidays();
		await this.viewModel.load_events();
		this.viewModel.initialize_datepickers();
		this.add_custom_calendar_css();
	};


	async load_calendar_colors()
	{
		let res = await Grape.fetches.postJSON('/general/get_leave_color_combinations', {});
		generateCSScolorCombinations(res);
	}

	async load_holidays()
	{
		let holiday_res = await Grape.fetches.postJSON('/leave/get_holidays', {});

	

		if (holiday_res?.get_holidays) {
			this.viewModel.holidays(holiday_res.get_holidays);
			
		}
			
		else
			this.viewModel.holidays.removeAll();
	}

	async load_events_list()
	{
		let options = {
			table: 'events',
			schema: 'public',
			limit: 1000, 
			filter: [
				{ value: new Date().toISOString().split('T')[0], op: '=', field: 'event_date'}
			]
		}

		let res = await Grape.fetches.getJSON('api/record', options );
		this.viewModel.events(res.records); 
	}



	async load_custom_fields(_leave_linked_id)
	{
		if (_leave_linked_id == undefined || _leave_linked_id == null || _leave_linked_id == 'undefined') { 
			document.getElementById("save_button").disabled = true;
			Grape.alerts.alert({type: 'error', message: tr('You have no leave linked to your profile'), title: tr('Error', 'Error')});
			return; 
		}

		let res = await Grape.fetches.postJSON('/leave/get_frontend_customization_fields', { 'leave_linked_id': _leave_linked_id });


		if (res.status == 'OK')
		{
			// this.viewModel.amount(res.amount_days);
			if (res.front_end_customization_fields != null)
			{
				let nicer_array = new Array();
				for (let a = 0; a < res.front_end_customization_fields.length; a++)
				{
					let obj = res.front_end_customization_fields[a].customization_frontend_fields;
					Object.keys(obj).forEach((key) => {
						let nice_obj = obj[key];
						nice_obj.vname = key;
						nicer_array.push(nice_obj);
					});
				}
				this.viewModel.customization_front_end_fields(nicer_array);
			} else
				this.viewModel.customization_front_end_fields.removeAll();
		}
		else if (res.status == 'ERROR')
		{
			document.getElementById("save_button").disabled = false;
			Grape.alerts.apiError(res);
		}
		else
		{
			document.getElementById("save_button").disabled = false;
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
		}
	};

	async calculate_data()
	{
		if (!this.viewModel.date_start() || !this.viewModel.date_end()) 
			return; // Exit if either start or end date is not set
		
		
		let sd = moment(this.viewModel.date_start(), "YYYY-MM-DD", true);
		let ed = moment(this.viewModel.date_end(), "YYYY-MM-DD", true);
	
		// Check if both dates are valid and fully entered
		if (!sd.isValid() || !ed.isValid()) 
			return; // Exit if either date is invalid or incomplete
		
	
		// Check if end date is not before start date
		if (ed.isBefore(sd))
		{
			this.viewModel.amount(0);
			this.viewModel.amount_info(tr('End date cannot be before start date'));
			return;
		}
	
		// Set end date to start date if it's null
		if (this.viewModel.date_end() === null)
		{
			this.viewModel.date_end(this.viewModel.date_start());
			ed = sd;
		}
	
		// Enable amount editing for single day entries
		if (sd.isSame(ed))
		{
			this.viewModel.is_amount_editable(true);
		} else
		{
			this.viewModel.is_amount_editable(false);
		}
	
		try {
			let res = await Grape.fetches.postJSON('/leave/calculate_work_days', {
				'_date_start': this.viewModel.date_start(),
				'_date_end': this.viewModel.date_end(),
				'leave_linked_id': this.viewModel.leave_linked_id()
			});
	
			if (res.status === 'OK')
				this.viewModel.amount(res.amount_days);
			else if (res.status === 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.viewModel.amount(0);
			} else
			{
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
				this.viewModel.amount(0);
			}
		} catch (error)
		{
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Something went wrong while calculating leave days..') + error.message});
			this.viewModel.amount(0);
		} 
		
		try {
			// check if date range selected doesn't already have leave assigned
			let res = await Grape.fetches.postJSON('/leave/is_leave_range_free', {
				'date_start': this.viewModel.date_start(),
				'date_end': this.viewModel.date_end(),
				'employee_id': this.bindings.employee_id
			});
			if (res.status !== 'ERROR')
			{
				// test calculate work days
				if (res.is_free != undefined)
					this.viewModel.is_overlapping(!res.is_free);
				else
					this.viewModel.is_overlapping(false);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Something went wrong while calculating leave days..') + error.message});
		}

		try {
			// get extra info - is this date range next to adjacent jewish holiday ?
			let res = await Grape.fetches.postJSON('/leave/is_date_range_adjacent_penalty_holiday', {
				'_date_start': this.viewModel.date_start(),
				'_date_end': this.viewModel.date_end(),
				'leave_linked_id': this.viewModel.leave_linked_id()
			});
			if (res.status == 'OK')
				this.viewModel.amount_info(res.result);
			else if (res.status == 'ERROR')
			{
				this.viewModel.amount_info('');
				Grape.alerts.apiError(res);
			}
			else
				this.viewModel.amount_info('');
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Something went wrong while calculating leave days..') + error.message});
		}

		try {
			let res = await Grape.fetches.getJSON('/leave/' + this.bindings.employee_id + '/summary/2000-01-01/' + this.viewModel.date_start(), {});
			if (res.status !== 'ERROR')
				this.viewModel.leave_summary(ko.mapping.fromJS(res));
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong while fetching leave summary...'), title: tr('Error', 'Error')});
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Something went wrong while fetching leave summary...') + error.message});
		}
	};

	async process_NEXT_leave_restriction_queue_item(data)
	{
		if (this.leave_restriction_queue === null || [])
		{
			await this.proceed_saving_leave(data);
			return;
		}

		let item = this.leave_restriction_queue.pop();

		switch (item.behaviour)
		{
			case 'warning_only':
				let response = await Grape.alerts.confirm({
					type: 'warning',
					title: tr('Notice'),
					message: item.message,
					accept_text: tr('Proceed'),
					cancel_text: tr('Cancel')
				});
				if (response)
					this.process_NEXT_leave_restriction_queue_item(data);
				else
					document.getElementById("save_button").disabled = false; // cancelled ( it will stop here as we dont call next item to process)

				break;
			case 'reject_leave_application':
				this.global_save_ok = false;
				Grape.alerts.alert({ type: 'error', message: item.message, title: tr('Unable to save leave') });
				document.getElementById("save_button").disabled = false;
				// ( it will stop here as we dont call next item to process)

				break;
		}
	};

	async proceed_saving_leave(data) {
		let formData = new FormData($('#batchuploadform')[0]);
		let URL;
		if (document.getElementById('batch_file').files[0]) {
			if (document.getElementById('batch_file').files[0].size > 20000000) {
				Grape.alerts.alert({ type: 'error', message: tr('File size exceeds the maximum limit of 20MB', 'File size exceeds the maximum limit of 20MB'), title: tr('Error', 'Error') });
				document.getElementById("save_button").disabled = false;
				formData.append('abort_upload', 'true');
				return;
			}
		}

		if (data.leave_taken_id == null)
			data.leave_taken_id = -1;
		
		URL = '/leave/save';
		if (data.leave_taken_id != -1)
			URL = '/leave/edit';
	
		if (this.global_save_ok == true) {
			// get leave type desc from the drop downs selected value
			let leave_type_description = $('#ddlLeaveType').find('option:selected').text();
			let leave_info = ko.utils.arrayFirst(this.viewModel.leave_summary().leave(), function (item) {
				return ko.unwrap(item.leave_type_id) === parseInt(data.leave_type_id);
			});

			let response = await Grape.alerts.confirm({ message: (`You are requesting: ${leave_type_description}  from  ${data.date_start}  to  ${data.date_end}.  Is this correct?`), type: 'warning', title: tr('Confirm Leave Request') });
			if (response) {
				let res = await Grape.fetches.postJSON(URL, data);
				if (res.status == 'OK') {
					if (this.viewModel.has_attachment() == true) {
						/* */
						formData.append('employee_id', this.bindings.employee_id);
						formData.append('transaction_id', res.transaction_id);
						formData.append('name', $('#upload_input').val());

						let xhr = new XMLHttpRequest();
						xhr.open('post', '/employee/upload_leave_document', true);
						xhr.setRequestHeader('Accept', 'application/json');
						xhr.send(formData);
					}
					await Grape.alerts.alert({
						type: 'success',
						message: tr('Successfully saved leave request.'),
						title: tr('Success')
					});
					Navbar.updateNotificationCount();
					this.close();
				} else if (res.status == 'ERROR') {
					Grape.alerts.apiError(res);
					document.getElementById("save_button").disabled = false;
				} else {
					document.getElementById("save_button").disabled = false;
					Grape.alerts.alert({
						type: 'error',
						message: tr('Something went wrong...'),
						title: tr('Error')
					});
				}
			}

			if (Grape.config.public_settings.get_leave_warning > 0 && leave_info)
			{
				let available_balance = ko.unwrap(leave_info.available_balance);
				let leave_warning = parseFloat(Grape.config.public_settings.get_leave_warning);
				let requested_amount = ko.unwrap(this.viewModel.amount());

				if (requested_amount > available_balance)
				{
					await Grape.alerts.alert({
						type: 'warning',
						message: tr(`Successfully saved leave request. \n\n Please note: Your available days for ${leave_info.leave_type()} is now in the negative. Kindly contact your manager for more information.`),
						title: tr('Success')
					});
					this.close();
					return;
				}

				if (available_balance < leave_warning)
				{
					await Grape.alerts.alert({
						type: 'warning',
						message: tr(`Successfully saved leave request. \n\n Please note: Your ${leave_info.leave_type()} is almost depleted. Kindly contact your manager for more information.`),
						title: tr('Success')
					});
					this.close();
					return;
				}
			}
		}
		document.getElementById("save_button").disabled = false;
	}

	add_custom_calendar_css()
	{
		const style = document.createElement('style');
		style.textContent = `
			.employee-leave-entry-dialog .flatpickr-calendar.end-date-calendar { 
				left: -1em;
			}

			.employee-leave-entry-dialog .flatpickr-calendar.static.open {
				display: inline-grid;
			}

			.employee-leave-entry-dialog .dayContainer {
				height: 222px;
				min-width: 238px;
				max-width: 238px;
			}

			.employee-leave-entry-dialog .flatpickr-days {
				width: 238px !important;
			}

			.employee-leave-entry-dialog .flatpickr-day {
				font-weight: 400;
				width: 34px;
				-webkit-flex-basis: 34px;
				-ms-flex-preferred-size: 34px;
				flex-basis: 34px;
				max-width: 34px;
				height: 34px;
				line-height: 34px;
				display: inline-block;
				margin: 0;
				text-align: center;
				padding: 0;
			}

			.employee-leave-entry-dialog .flatpickr-calendar.open, 
			.employee-leave-entry-dialog .flatpickr-calendar.inline {
				opacity: 1;
				max-height: 640px;
				visibility: visible;
				height: 241px;
				width: 238px;
			}

			.employee-leave-entry-dialog .flatpickr-month {
				height: 34px;
				display: flex;
				align-items: center;
				padding: 4px 0;
			}

			.employee-leave-entry-dialog .flatpickr-current-month {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 101%;
				height: 35px;
				padding: 1;
				font-size: 15px;
			}

			.employee-leave-entry-dialog .flatpickr-current-month .cur-month {
				margin-right: 4px;
			}

			.employee-leave-entry-dialog .numInputWrapper {
				width: 54px;
				margin-right: 3em;
				margin-left: 1.5em;
				font-size: 11px;
			}

			.employee-leave-entry-dialog .flatpickr-monthDropdown-months {
				font-size: 17px;
				font-weight: 400;
				height: 22px;
				padding: 0 4px;
			}

			.employee-leave-entry-dialog .numInput.cur-year {
				font-size: 14px;
				height: 22px;
				padding: 0 4px;
			}

			.employee-leave-entry-dialog .flatpickr-weekdays {
				height: 28px;
				display: flex;
				align-items: center;
			}

			.employee-leave-entry-dialog .flatpickr-weekday {
				width: 34px;
				max-width: 34px;
				flex: 0 0 34px;
				margin: 0;
				text-align: center;
				font-size: 12px;
			}

			.employee-leave-entry-dialog #datepicker_start + .flatpickr-calendar {
				left: -1em;
			}

			.employee-leave-entry-dialog .flatpickr-months .flatpickr-prev-month,
			.employee-leave-entry-dialog .flatpickr-months .flatpickr-next-month {
				height: 34px;
				padding: 4px;
				display: flex;
				align-items: center;
				justify-content: center;
			}`;
		document.head.appendChild(style);

		// Apply the custom class to the end date picker
		if (this.viewModel.end_date_picker) {
			this.viewModel.end_date_picker.calendarContainer.classList.add('end-date-calendar');
		}
	}
};

export default {
	name: 'EmployeeLeaveEntry',
	dialog_class: EmployeeLeaveEntryPage,
	template: template,
	template_filename: 'translation/dialogs/employee_leave_entry',
	provider: 'ps'
};
